import { isPlainObject } from 'lodash'
import type { FilterExpression } from '@wix/wix-data-client-common-standalone'
import { filterResolverKey as RESOLVER_KEY } from '@wix/wix-data-client-common-standalone'

const RESOLVER_VALUE = 'slug'

export const addSlugResolver = () => {
  return { [RESOLVER_KEY]: RESOLVER_VALUE }
}

export const shouldResolveSlug = (filterExpression: FilterExpression) =>
  isPlainObject(filterExpression) &&
  filterExpression[RESOLVER_KEY] === RESOLVER_VALUE
